import { computed } from "vue";
import {
  loadFlagsConfig,
  useFlagsConfig,
  FlagName,
} from "@/config/flagsConfig";
import { isHarnessFlagsSource } from "@/config/flags/flagsSource";
import { getHarnessTreatment } from "@/config/split/harnessFlags";
import { treatmentToBoolean } from "@/config/split/splitClient";

export const useFlag = (flagName: FlagName) => {
  const flagsConfig = useFlagsConfig();
  loadFlagsConfig();

  const staticValue = computed<boolean>(() => {
    const feature = flagsConfig.value?.[flagName];
    if (typeof feature !== "boolean") return false;
    return feature;
  });

  const isFeatureAvailable = computed<boolean>(() => {
    if (!isHarnessFlagsSource()) return staticValue.value;

    // Harness source. Until the SDK is ready — or for flags not (yet)
    // configured in Harness — the treatment is "control"; fall back to the
    // static value so nothing flickers or breaks during migration.
    const treatment = getHarnessTreatment(flagName);
    if (treatment === "control") return staticValue.value;
    return treatmentToBoolean(treatment);
  });

  return { isFeatureAvailable };
};
